import React from "react";
import "./scss/About.css";
import { HeaderText } from "../../styledcomponents/HeaderText/HeaderText";
import { SectionHeader } from "../../styledcomponents/SectionHeader/SectionHeader";

import "animate.css/animate.min.css";
import ScrollAnimation from "react-animate-on-scroll";

import iconSet from "../../icons/selection.json";
import IcomoonReact, { iconList } from "icomoon-react";

const About = (props) => {
  var lastScroll = 0;

  window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll == 0) {
      //for the card
      document
        .getElementsByClassName("about__card")[0]
        .classList.remove("animate");

      //for the icon
      document
        .getElementsByClassName("about__icon")[0]
        .classList.remove("pulsate");
      document
        .getElementsByClassName("about__icon")[1]
        .classList.remove("pulsate");
      document
        .getElementsByClassName("about__icon")[2]
        .classList.remove("pulsate");
      document
        .getElementsByClassName("about__icon")[3]
        .classList.remove("pulsate");

      return;
    }

    if (currentScroll > lastScroll) {
      // down
      document
        .getElementsByClassName("about__card")[0]
        .classList.add("animate");

      document
        .getElementsByClassName("about__icon")[0]
        .classList.add("pulsate");
      document
        .getElementsByClassName("about__icon")[1]
        .classList.add("pulsate");
      document
        .getElementsByClassName("about__icon")[2]
        .classList.add("pulsate");
      document
        .getElementsByClassName("about__icon")[3]
        .classList.add("pulsate");
    } else if (currentScroll < lastScroll) {
      // up
      //document.getElementsByClassName("about__card")[0].classList.remove("animate");
    }

    lastScroll = currentScroll;
  });

  return (
    <div className="about" id="about">
      <div className="about__container">
        <div className="about__left">
          <div className="about__card">
            <div className="about__imgbox">
              <svg
                viewBox="0 0 500 500"
                className="blob"
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                id="blobSvg"
              >
                <path
                  className="path"
                  id="blobbb"
                  d="M452.5,284Q438,318,395,327Q352,336,360.5,396Q369,456,328.5,461Q288,466,250.5,464Q213,462,170,463Q127,464,133.5,403Q140,342,83,336.5Q26,331,57,290.5Q88,250,103.5,226Q119,202,105.5,160Q92,118,116,88.5Q140,59,179,63.5Q218,68,246.5,89Q275,110,295,124Q315,138,346.5,140.5Q378,143,381,172Q384,201,425.5,225.5Q467,250,452.5,284Z"
                  fill="#606c88"
                ></path>
              </svg>
            </div>

            <HeaderText style={{ zIndex: 1000 }}>Hello!</HeaderText>

            <div className="intouch">
              <p>
                Lets get in touch.
                <br />
                Links to my socials are below.
              </p>
            </div>

            <div className="about__grid">
              <a href="https://www.twitter.com/szakari6">
                <div className="about__icon">
                  <IcomoonReact
                    iconSet={iconSet}
                    color="currentColor"
                    style={{ height: "2rem", width: "2rem", margin: "0 auto" }}
                    icon="twitter"
                  />
                </div>
              </a>

              <a href="https://www.linkedin.com/in/muhammad-salim-zakari-2929321b1">
                <div className="about__icon">
                  <IcomoonReact
                    iconSet={iconSet}
                    color="currentColor"
                    style={{ height: "2rem", width: "2rem", margin: "0 auto" }}
                    icon="linkedin2"
                  />
                </div>
              </a>

              <a href="https://www.instagram.com/szakari6">
                <div className="about__icon">
                  <IcomoonReact
                    iconSet={iconSet}
                    color="currentColor"
                    style={{ height: "2rem", width: "2rem", margin: "0 auto" }}
                    icon="instagram"
                  />
                </div>
              </a>

              <a href="https://app.pluralsight.com/profile/muhammadsalim-zakari">
                <div className="about__icon">
                  <IcomoonReact
                    iconSet={iconSet}
                    color="currentColor"
                    style={{ height: "2rem", width: "2rem", margin: "0 auto" }}
                    icon="pluralsight"
                  />
                </div>
              </a>
            </div>
          </div>
        </div>

        <div className="about__right">
          <ScrollAnimation
            animateIn="animate_about"
            animateOnce={true}
            duration={0.7}
          >
            <SectionHeader>About me</SectionHeader>

            <p>
              Hi 😄, I am Salim! I am a Frontend Engineer with flair for
              Software Development. Proficient in developing Frontend
              Applications using Angular, React and React Native. I enjoy
              building fast and efficient applications. I take pride in
              implementing features from design into working functionality in
              production 🚀
            </p>

            <p style={{ marginTop: "1rem" }}>
              I write maintanable and clean codes. I am inquisitive, open minded
              and always self driven to learn new concepts
            </p>
          </ScrollAnimation>
        </div>

        <svg
          style={{ display: "none" }}
          viewBox="0 0 500 500"
          className="blob"
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          id="blobSvg"
        >
          <path
            className="path"
            id="blobbb"
            d="M403.5,333.5Q347,417,247,422.5Q147,428,121.5,339Q96,250,119,156.5Q142,63,228,101.5Q314,140,387,195Q460,250,403.5,333.5Z"
            fill="#606c88"
          ></path>
        </svg>
      </div>
    </div>
  );
};
export default About;
